export default {
    API_PFX: '/v1',
    API_URL: process.env.VUE_APP_API_URL,
    APP_URL: process.env.VUE_APP_APP_URL,
    APP_KEY: process.env.VUE_APP_APP_KEY,
    APP_SALT: process.env.VUE_APP_APP_SALT
}